<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Potencial por Cliente"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Ano Safra"
              @input="populateLimit"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              placeholder="Selecione o Vendedor"
              v-model="filter.salesman"
              :options="filteredSalesmen"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :loading="loading.salesman"
              label="name"
              track-by="id"
              :disabled="DisabledSalesmanFilter"
              @input="findClients('')"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Cliente</label>
            <multiselect
              placeholder="Selecione o Cliente"
              v-model="filter.client"
              :options="filter.clients"
              :loading="isLoadingClients"
              label="razao_social"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              @input="getCultures"
              @search-change="findClients"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Cultura</label>
            <multiselect
              :loading="loading.culture"
              placeholder="Selecione a Cultura"
              v-model="filter.culture"
              :options="cultures"
              label="description"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :disabled="disableCultureFilter"
            />
          </div>
        </div>
        <div class="row justify-content-end" style="padding: 1rem">
          <base-button
            type="neutral"
            color="green"
            @click="clearFilters"
            >Limpar Filtros
          </base-button>
        </div>

        <div slot="footer" class="row justify-content-end mr-2">
          <el-tooltip placement="top" content="É necessário selecionar um cliente para gerar este relatório">
            <div>
              <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
              <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF" :disabled="disableClientFilter"
                >Gerar PDF</base-button
              >
              <base-button type="secondary" class="ml-2 mt-2" @click="exportToExcel()" :disabled="disableClientFilter"
                >Gerar Excel</base-button
              >
              <base-button
                type="primary"
                @click="generateReport"
                :loading="isLoading"
                class="ml-2 mt-2"
                :disabled="disableClientFilter"
                >Gerar Relatório</base-button
              >
            </div>
          </el-tooltip>
        </div>
      </card>
    </div>

    <card v-if="Object.keys(tableData).length === 0" class="col">
      <h4 class="text-uppercase text-muted ls-1 mb-1 text-center">
        Não possui relatório
      </h4>
    </card>

    <card
      v-else
      ref="report"
      v-loading="isLoading"
    >
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Potencial por Cliente - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.salesman && Object.keys(filter.salesman).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Vendedor - {{ filter.salesman.name }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Potential por Cliente - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ filter.anosafra.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesmen && Object.keys(filter.salesmen).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <br />
        <br />
        <br />
      </div>

      <card v-for="(data, index) in tableData" :key="`${tableData}-${index}`">
        <el-table
          :data="data.groups"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column :label="`${data.culture_name} - Área: ${data.groups[0].area}`">
            <el-table-column :label="data.cicle_name">
              <el-table-column
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <!-- Classificação -->
              <el-table-column
                label="Classificação Ciclo"
                prop="classification"
                min-width="125px"
                sortable
              />
              <el-table-column
                :formatter="numberFormatter"
                label="Índice Tec."
                prop="techonological_index"
                min-width="125px"
                sortable
              />
              <el-table-column
                :formatter="numberFormatter"
                label="Índice Tec.Vegetal"
                prop="technological_index_vegetal"
                min-width="125px"
                sortable
              />
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
      </card>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import { Table, TableColumn } from "element-ui";
import Card from "../../components/Cards/Card.vue";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    Card,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anosafra: {},
        goalType: "Vendedor",
        salesman: {},
        client: null,
        clients: [],
        isLoadingClients: false,
        dateLimit: null,
        tableName: [],
        grupo_id: [],
        manager: {},
        tableColumn: [],
        culture: {},
      },
      salesmen: [],
      filteredSalesmen: [],
      clients: [],
      cultures: [],
      anosafras: [],
      goalTypes: [],
      groups: [],
      tableData: [],
      lastEdition: new Date(),
      dateLimit: [],
      loading: {
        salesman: false,
        culture: false,
      },
      loadingSalesmen: false,
      isLoading: false,
      salesmen_type: "",
      currentUser: {},
      requestIndex: {
        generateReport: 0,
        cultures: 0,
        getsalesmans: 0,
        clients: 0,
        anosafras: 0,
      },
    };
  },
  computed: {
    disableClientFilter(){
      return !this.filter.client
    },
    disableCultureFilter(){
      return !this.filter.client || Object.keys(this.filter.client).length === 0;
    },
    disabledSalesmanFilter() {
      return !this.currentUser.is_admin && !this.currentUser.is_manager;
    },
  },
  methods: {
    clearFilters() {
      this.filter.anosafra = {},
      this.filter.salesman = {},
      this.filter.client = null,
      this.filter.culture = {}
    },
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    async generateReport() {
      this.isLoading = true;
      const currentRequestIndex = ++this.requestIndex.generateReport;

      try {
        const response = await this.$http.secured.get(
          "/api/v1/report/potential_table_data",
          {
            params: {
              salesman_id: this.filter.salesman.id,
              anosafra_id: this.filter.anosafra.id,
              client_id: this.filter.client.id,
              culture_id: this.filter.culture.id
            },
          }
        );

        if (currentRequestIndex !== this.requestIndex.generateReport) return;

        this.lastEdition = new Date();
        this.tableData = response.data;
      } catch (error) {}
      this.isLoading = false;
    },
    async getCultures() {
      const currentRequestIndex = ++this.requestIndex.cultures;
      this.loading.culture = true;
      try {
        const response = await this.$http.secured.get("/api/v1/cultures",{
          params: {
            unpaged: true,
              q: { client_id: this.filter.client
                  ? this.filter.client.id
                  : null,}
           },
        })

        if (currentRequestIndex !== this.requestIndex.cultures) return;

        this.cultures = response.data;
      } catch (error) {
        console.warn("[PotentialClients][getCultures] request error", error)
      }
      this.loading.culture = false;
    },
    getSummaries(param) {
      if (!Object.keys(param).length) return;

      var { columns, data } = param;
      var sums = [];

      for (const index in columns) {
        if (index == 0) {
          sums[index] = "TOTAL";
          continue;
        }
        if (index == 1) {
          sums[index] = "";
          continue;
        }
        if (index == 4) {
          sums[index] = "";
          continue;
        }

        var values = data.map((item) => Number(item[columns[index].property]));

        sums[index] = values.reduce(
          (prev, curr) => (Number(curr) || 0) + prev,
          0
        );
      }

      sums[2] = parseFloat(sums[2]).toLocaleString("pt-BR", {
        style: "currency",
        currency: "brl",
      });
      sums[3] = parseFloat(sums[3]).toLocaleString("pt-BR", {
        style: "currency",
        currency: "brl",
      });
      return sums;
    },
    async initSalesmen(query="") {
      const currentRequestIndex = ++this.requestIndex.getsalesmans;
      this.loading.salesman = true;
      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            q: {
              is_salesman: true,
              name:        query,
              manager_id:  this.filter.manager  && this.filter.manager.id,
              anosafra_id: this.filter.anosafra && this.filter.anosafra.id
            },
          },
        })

        if (currentRequestIndex !== this.requestIndex.getsalesmans) return;

        this.filter.salesmans = response.data;
        this.salesmen = response.data.users;
        this.filteredSalesmen = this.salesmen;
        this.loading.salesman = false;
      } catch (error) {
        console.warn("[PotentialClients][initSalesmen]", error);
      }
    },
    initClients(q = "") {
      const currentRequestIndex = ++this.requestIndex.clients;

      this.$http.secured
        .get("/api/v1/clients", { params: { q: { razao_social: q } } })
        .then((response) => {
          if (currentRequestIndex !== this.requestIndex.clients) return;

          this.clients = response.data.clients;
        });
    },
    findClients(query) {
      const currentRequestIndex = ++this.requestIndex.clients;
      this.isLoadingClients = true;
      var data = {
        per_page: 10,
        q: {},
      };

      if (query.trim()) data.q.razao_social = query;
      if (this.filter.salesman && this.filter.salesman.id)
        data.q.user_ids = this.filter.salesman.id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          if (currentRequestIndex !== this.requestIndex.clients) return;

          this.filter.clients = response.data.clients;
          this.isLoadingClients = false;
        })
        .catch(() => {
          // this.$toasted.defaultError(),
          this.isLoadingClients = false;
        });
    },
    populateLimit(value) {
      this.dateLimit = this.dateRange(value.start_date, value.end_date);
    },
    numberFormatter(_row, _column, value) {
      return parseFloat(value || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    filterSalesmen(manager) {
      this.filteredSalesmen = manager.salesmans;
    },
    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push(["01", displayMonth, i].join("/"));
        }
      }
      return dates;
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.getCultures();
    if (this.$can("index", "user")) {
      this.initSalesmen("");
      this.initClients("");
      this.findClients("");
    }

    this.currentUser = this.$currentUser();

    if (this.currentUser.is_admin) {
    } else if (this.currentUser.is_manager) {
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.salesman = this.currentUser;
      this.filter.manager = this.currentUser.manager;
    }
  },
  watch: {
    "filter.tableName": function (val) {},

    "filter.anosafra": function () {
      if (this.$can("index", "user")) {
        this.initSalesmen("");
      }
    },
    "filter.manager": function () {
      if (this.$can("index", "user")) {
        this.initSalesmen("");
      }
    },
  },
};
</script>
<style scoped>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}

#tableId {
  width: 100%;
}
</style>
